import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import Selected from "../../Inputs/Selected";
import Title from "../../Title/Title";

export default function Sorting_Hall_Secretaries() {
  return (
    <>
      <Row>
        <Col>
          <Title title="فرز أمناء القاعات" />
        </Col>
      </Row>

      <Row justify={"center"}>
        <Col lg={10} md={6} sm={6} className=" !mb-0">
          <Selected
            title="اسم المقرر"
            //   name="payment_method_id"
            // text="أختر اسم المقرر"
            value={""}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
              //   handleChangeInput(e);
              // setSelectedOptionType(e.target.options[e.target.selectedIndex].dataset.type)
            }}
            className="w-full max-lg:!w-full mb-5"
          >
            {/* {dataPayment?.data?.data?.map((e) => ( */}
            <option
            // key={e.id} value={e.id} data-type ={e.type}
            >
              {/* {e.name} */}
              React
            </option>
            {/* ))} */}
            <option>HTML</option>
            <option>CSS</option>
            <option>JS</option>
          </Selected>
        </Col>
      </Row>

      <Row>
        <Col lg={10} md={4} className="mx-auto">
          <table className="w-full bg-gray-50  max-lg:w-[850px] mx-auto my-5 text-center rounded-2xl overflow-hidden ">
            <thead className=" bg-[#efc5e6] text-black h-[70px] font-bold text-base">
              <tr>
                <td className="px-1">اسماء القاعات</td>
                <td className="px-16"> اسماء الموظفين</td>
              </tr>
            </thead>

            <tbody className="h-[70px]">
              <tr className="border-2 border-Secondary">
                <td className="text-xl">اسم القاعة</td>
                <td>
                  <Selected
                    title="أختر "
                    //   name="payment_method_id"
                    // text="أختر اسم المقرر"
                    value={""}
                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      //   handleChangeInput(e);
                      // setSelectedOptionType(e.target.options[e.target.selectedIndex].dataset.type)
                    }}
                    className="!w-[60%] max-lg:!w-full mb-3"
                  >
                    {/* {dataPayment?.data?.data?.map((e) => ( */}
                    <option
                    // key={e.id} value={e.id} data-type ={e.type}
                    >
                      {/* {e.name} */}
                      React
                    </option>
                    {/* ))} */}
                    <option>HTML</option>
                    <option>CSS</option>
                    <option>JS</option>
                  </Selected>
                </td>
              </tr>
            </tbody>
          </table>
        </Col>
      </Row>
    </>
  );
}
